export const GET_PRODUCTSALES_REPORT='GET_PRODUCTSALES_REPORT'
export const GET_PRODUCTSALES_REPORT_SUCCESS='GET_PRODUCTSALES_REPORT_SUCCESS'
export const GET_PRODUCTSALES_REPORT_ERROR='GET_PRODUCTSALES_REPORT_ERROR'

export const GetProductSalesReport = (data) => ({
    type: GET_PRODUCTSALES_REPORT,
    payload: data
})